/* eslint-disable max-len */
import styles from './onboarding.module.scss';
import Double_arrow from '../../../Assets/images/svg/Double_arrow.svg';
import React, { useRef, useContext } from 'react';
import { Typography, Card, CardContent, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../Contexts/AuthContext';
import defaultImage from '../../../Assets/images/svg/user_circle.svg';
import { formatDate } from '../../../Utils/formatDate';
import noDataIcon from '../../../Assets/images/svg/no-data-search-icon.svg';
import { MODULE_NAMES } from '../../../Constants/modules';

const OnboardingPage = ({ organizationDetails, totalExperience, hiringDetails, loading }) => {
  const carouselRefOrg = useRef(null);
  const handleNextSlide = () => {
    if (carouselRefOrg.current) {
      const slider = carouselRefOrg.current;
      slider.scrollLeft += 300;
    }
  };
  // eslint-disable-next-line react/prop-types
  const showDoubleArrow = organizationDetails?.length > 3;
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_ONBOARDING] || []
    : [];

  const hasAccess = (action) => {
    const access = permission.includes(action);
    return access;
  };

  if (loading){
    return <div><CircularProgress/></div>;
  }
  return (
    <div className={styles['onboarding-page']}>
      <div className={styles['onboarding-page-outer-div']}>
        <div className={styles['onboarding-page-heading-div']}>
          <div className={styles['onboarding-heading-name']}>
            Hiring details
          </div>
        </div>
        <div className={styles['hiring-details-sec']}>
          <div className={styles['hiring-details-sec-inner']}>
            {hasAccess('read') && (
              <>
                {!loading && hiringDetails?.map((interview, index) => (
                  <div key={interview?.id} className={styles['container']}>
                    <div className={styles['round-circle']}>
                      <div className={styles['round-text']}>Round</div>
                      <div className={styles['number-text']}>{index + 1}</div>
                    </div>
                    <div className={styles['text-container']}>
                      <div className={styles['technical-text']}>
                        {interview.interviewRounds}
                      </div>
                      <div className={styles['date-text']}>
                        {formatDate(interview?.interviewTime)}
                      </div>
                    </div>
                    <div className={styles['image-circle']}>
                      <img
                        src={interview?.interviewer?.photoSignedUrl || defaultImage}
                        alt="Description"
                      />
                    </div>
                    <div className={styles['person-details']}>
                      <div className={styles['name']}>
                        {interview?.interviewer?.full_name || 'NA'}
                      </div>
                      <div className={styles['emplyee-id']}>
                        {interview?.interviewer?.employee_id || 'NA'}
                      </div>
                    </div>
                  </div>
                ))}
                {!loading && hiringDetails?.length === 0 && (
                  <div className={styles['no-data-container']}>
                    <div className={styles['no-data-wrapper']}>
                      <span className={styles['no-data-icon']}>
                        <img src={noDataIcon} alt="No data" />
                      </span>
                      <span className={styles['no-data-text']}>
                      No data to display
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* Previous organization details section */}
      {hasAccess('read') && (
        <div className={styles['organization-page-outer-div']}>
          <div className={styles['organization-page-heading-div']}>
            <Typography className={styles['organization-heading-name']}>
              Previous organization details
            </Typography>
            <Typography className={styles['experience-text']}>
              <span className={styles['label-text']}>Total previous experience:</span>
              <span className={styles['value-text']}>{totalExperience || 'No experience available'}</span>
            </Typography>
          </div>
          <div className={styles['org-carousel-container']}>
            {showDoubleArrow && (
              <img
                src={Double_arrow}
                alt="Next"
                className={styles['double-arrow']}
                onClick={handleNextSlide}
              />
            )}
            <div ref={carouselRefOrg} className={styles['org-carousel']}>
              {organizationDetails && organizationDetails.length > 0 ? (
                // eslint-disable-next-line react/prop-types
                organizationDetails.map((experience, index) => (
                  <>
                    {experience?.employer ? (
                      <div key={index} className={styles['org-carousel-item']}>
                        <Card>
                          <CardContent>
                            <Typography className={styles['org-name']}>
                              {experience.employer}
                            </Typography>
                            <Typography className={styles['org-details']}>
                              {experience.jobtitle}
                            </Typography>
                            <Typography className={styles['org-date']}>
                              {experience.fromDate} - {experience.toDate}
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    ) : null}
                  </>
                ))
              ) : (
                <Typography>No previous employment details available.</Typography>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

OnboardingPage.propTypes = {
  organizationDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalExperience: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  hiringDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default OnboardingPage;
